module.exports = __webpack_public_path__ + "static/img/fish16.03ea0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish16.png
// module id = nW8e
// module chunks = 0